module.exports = __webpack_public_path__ + "img/LOGO_B_SMALL.516af391.png";